// The assistant's conversations, kept in this browser. Today's carries on
// across reloads. When a new day starts it moves to the archive, where it
// can be read and picked up again for one day; after that it's gone.

import { localDateString } from './tools';
import { withoutDashes } from '../utils/text';

// The reply's last line names what the user is likely to ask next
// ("Next: Mark Read as done"). It's taken off what's shown and offered in the
// text box instead
const NEXT = /\n\s*Next:\s*(.+?)\s*$/is;
export const splitNext = (text) => {
  const match = String(text).match(NEXT);
  if (!match) return { text: String(text).trim(), next: null };
  // Shown in the text box and sent as the user's words, so no dashes there either
  const next = withoutDashes(match[1].replace(/^["“]|["”]$/g, '')).trim();
  return { text: String(text).slice(0, match.index).trim(), next: next || null };
};
// While a reply streams in, hide its "Next:" line as soon as it starts to appear
export const hideNext = (text) => String(text).replace(/\n\s*(N|Ne|Nex|Next|Next:.*)$/s, '').trimEnd();

const key = (uid) => `mind_chat_${uid}`;
export const yesterdayOf = (day) => {
  const [y, m, d] = day.split('-').map(Number);
  return localDateString(new Date(y, m - 1, d - 1));
};

// Entries hold Dates (a message's time); storage holds strings
const revive = (entries) => (entries || []).map((e) => (e.time ? { ...e, time: new Date(e.time) } : e));
const empty = (chat) => !chat || !(chat.entries || []).length;

/**
 * { current, archive } for `today`: a stored conversation from an earlier
 * day becomes the archive if that day was yesterday, and is dropped if older.
 * Each is { day, entries, messages } or null.
 */
export const loadChats = (uid, today = localDateString()) => {
  let saved = null;
  try {
    saved = JSON.parse(localStorage.getItem(key(uid)) || 'null');
  } catch {
    saved = null;
  }
  const yesterday = yesterdayOf(today);
  let current = saved?.current || null;
  let archive = saved?.archive || null;
  if (current && current.day !== today) {
    if (!empty(current) && current.day === yesterday) archive = current;
    current = null;
  }
  if (archive && (archive.day !== yesterday || empty(archive))) archive = null;
  const shape = (c) => (c ? { day: c.day, entries: revive(c.entries), messages: c.messages || [] } : null);
  return { current: shape(current), archive: shape(archive) };
};

export const saveChats = (uid, { current, archive }) => {
  try {
    // A reply still being written isn't kept half-done
    const settled = (c) => (c && !empty(c) ? { ...c, entries: c.entries.filter((e) => !e.streaming) } : null);
    localStorage.setItem(key(uid), JSON.stringify({ current: settled(current), archive: settled(archive) }));
  } catch {
    // Full or private storage: the conversation still works, it just isn't kept
  }
};
